
  export default {
    props: {
      field: { type: String, required: true },
      modelName: { type: String, required: true },
      radioOptions: { type: Array, default () { return []; } },
      inputAttrs: { type: Object, default () { return {}; } },
      required: { type: Boolean, default: false }
    },
    data () {
      return { scopeId: null };
    },
    computed: {
      selectedValue () {
        return this.search[this.field];
      },
      search () {
        return this.$store.getters['search/get'];
      },
      attribute: {
        get () {
          return this.$formGet(this.modelName, this.field);
        },
        set (v) {
          this.$emit('input', v);
        }
      }
    },
    mounted () {
      this.scopeId = this.$uuid.v4();
    },
    methods: {
      elId (option) {
        return [this.scopeId, option.toString()].join('_');
      },
      icon (index) {
        const key = [this.modelName, this.field].join('.');
        return this.$t(key).fields[index].icon || 'circle';
      },
      scrollToFirstError () {
        const firstError = this.$refs.radio.reduce((acc, el) => {
          if (el.name && el.form && !el.form.checkValidity()) {
            const invalidEls = el.form.querySelectorAll(`[name="${el.name}"]:invalid`);
            if (invalidEls.length && !acc) {
              acc = invalidEls[0];
            }
          }
          return acc;
        }, null);

        if (firstError) {
          firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      },
      scrollToFirstErrorWithDelay () {
        setTimeout(() => {
          this.scrollToFirstError();
        }, 200);
      }
    }
  };
